// extracted by mini-css-extract-plugin
export default {"body":"BhlsP5clFyGpIVgZuvGQ","input":"vcZ7DCRgbpatTsyJ0vd1"};